import React from 'react';
import { SvgIcon } from '@mui/material';

export default function CalendarIcon({ sx, ...props }) {
  const firstColor = props.color || '#4520AB';
  const secondColor = '#ffffff';
  return (
    <SvgIcon
      viewBox="0 0 24 24"
      sx={{ width: 24, height: 24, ...sx }}
      {...props}
    >
      <rect width="24" height="24" rx="8" fill={firstColor} />
      <rect
        x="10.9609"
        y="6"
        width="2.08333"
        height="2.08333"
        rx="0.833333"
        fill={secondColor}
      />
      <rect
        x="16.125"
        y="6"
        width="2.08333"
        height="2.08333"
        rx="0.833333"
        fill={secondColor}
      />
      <rect
        x="5.79297"
        y="6"
        width="2.08333"
        height="2.08333"
        rx="0.833333"
        fill={secondColor}
      />
      <rect
        x="10.9609"
        y="10.958"
        width="2.08333"
        height="2.08333"
        rx="0.833333"
        fill={secondColor}
      />
      <rect
        x="16.125"
        y="10.958"
        width="2.08333"
        height="2.08333"
        rx="0.833333"
        fill={secondColor}
      />
      <rect
        x="5.79297"
        y="10.958"
        width="2.08333"
        height="2.08333"
        rx="0.833333"
        fill={secondColor}
      />
      <rect
        x="10.9609"
        y="15.917"
        width="2.08333"
        height="2.08333"
        rx="0.833333"
        fill={secondColor}
      />
      <rect
        x="16.125"
        y="15.917"
        width="2.08333"
        height="2.08333"
        rx="0.833333"
        fill={secondColor}
      />
      <rect
        x="5.79297"
        y="15.917"
        width="2.08333"
        height="2.08333"
        rx="0.833333"
        fill={secondColor}
      />
    </SvgIcon>
  );
}
